import * as e from "react";
import i from "../lib/IconBase.es.js";
import m from "../defs/DeviceMobileCamera.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(i, { ref: r, ...a, weights: m }));
o.displayName = "DeviceMobileCameraIcon";
const s = o;
export {
  s as DeviceMobileCamera,
  o as DeviceMobileCameraIcon
};
